// src/services/authService.js

import { post, get } from './api'; // Importe les fonctions génériques de l'API

// Ces endpoints doivent correspondre à ceux de votre Microservice d'Authentification & Autorisation
const AUTH_API_BASE = '/auth'; // Ex: /api/auth

// Fonction pour la connexion de l'utilisateur
export const login = async (credentials) => {
  try {
    const response = await post(`${AUTH_API_BASE}/login`, credentials);
    return response;
  } catch (error) {
    console.error('Erreur lors de la connexion:', error);
    throw error; // Propage l'erreur pour la gestion dans le contexte ou le composant
  }
};

// Fonction pour l'inscription de l'utilisateur
export const register = async (userData) => {
  try {
    const response = await post(`${AUTH_API_BASE}/register`, userData);
    return response;
  } catch (error) {
    console.error('Erreur lors de l\'inscription:', error);
    throw error;
  }
};


export const verifyOtp = async (otpData) => {
  try {
    const response = await post(`${AUTH_API_BASE}/verify-otp`, otpData);
    return response;
  } catch (error) {
    console.error('Erreur lors de la verification du code OTP:', error);
    throw error;
  }
}

export const authResendOtp = async (phone) => {
  try {
    const response = await post(`${AUTH_API_BASE}/resend-otp`, { phone });
    return response;
  }catch(error){
    console.error('Erreur lors de la verification du code OTP:', error)
    throw error
  }
}

export const authSendPasswordForgottenRequest = async (email) => {
  try {
    const response = await post(`${AUTH_API_BASE}/password-forgotten`, { email });
    return response;
  }catch(error){
    console.log("Erreur lors de la demande de mot de passe oublié",error)
    throw error
  }
}

export const authResetPassword = async (passwordData) => {
  try {
    const response = await post(`${AUTH_API_BASE}/password-reset`, passwordData);
    return response;
  }catch(error){
    console.log("Erreur lors de la redefinition du mot de passe",error)
    throw error
  }
}



// Fonction pour la déconnexion (principalement côté client, suppression du token)
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  console.log('Utilisateur déconnecté (token supprimé du stockage local).');
};

// Fonction pour vérifier le token (peut être utilisée pour valider le token avec le backend)
// C'est optionnel, souvent le backend valide le token à chaque requête protégée.
// Mais si vous avez un endpoint de validation, vous pouvez l'appeler ici.
export const validateToken = async (token) => {
  if (!token) {
    return false;
  }
  try {
    // Exemple: un endpoint qui renvoie les infos utilisateur si le token est valide
    const response = await get(`${AUTH_API_BASE}/validate-token`, token);
    return response.isValid; // Ou renvoie les infos utilisateur
  } catch (error) {
    console.error('Erreur lors de la validation du token:', error);
    return false;
  }
};

// Fonction pour récupérer les informations de l'utilisateur à partir du token (si le token est JWT auto-décodable)
// Ou, plus communément, les infos utilisateur sont renvoyées lors du login et stockées.
export const getUserFromToken = (token) => {
  if (!token) return null;
  try {
    // Si le token est un JWT standard, vous pouvez le décoder côté client.
    // ATTENTION: Cela ne vérifie PAS la validité du token avec le backend.
    // C'est utile pour afficher des informations utilisateur rapidement sans appel API.
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Erreur de décodage du token:", e);
    return null;
  }
};
